import { API_BASE_URL } from 'app/constants';

export const DESTINATION_URL = `${API_BASE_URL}/destination/`;
export const CARRIER_URL = `${API_BASE_URL}/carrier/`;
export const ORDER_URL = `${API_BASE_URL}/order/`;
export const PARTORDER_URL = `${API_BASE_URL}/part-order/`;
